import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  value: {
    name: "",
    lastName: "",
    email: "",
  },
  validEmail: true,
  validDomain: true,
};

const registerFormSlice = createSlice({
  name: "registerForm",
  initialState,
  reducers: {
    onFormChanges: (state, action) => {
      state.value = action.payload;
    },
    setEmailValidation: (state, action) => {
      state.validEmail = action.payload;
    },
    setDomainValidation: (state, action) => {
      state.validDomain = action.payload;
    },
    resetRegisterForm() {
      return initialState;
    },
  },
});

export const {
  onFormChanges,
  setDomainValidation,
  setEmailValidation,
  resetRegisterForm,
} = registerFormSlice.actions;
export default registerFormSlice.reducer;
